import { render, staticRenderFns } from "./CountryInfo.vue?vue&type=template&id=0d126c1c&scoped=true&"
import script from "./CountryInfo.vue?vue&type=script&lang=js&"
export * from "./CountryInfo.vue?vue&type=script&lang=js&"
import style0 from "./CountryInfo.vue?vue&type=style&index=0&id=0d126c1c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d126c1c",
  null
  
)

export default component.exports